export const ASSET_TYPES: Record<string, string> = {
	body: 'bodies',
	hair: 'hairs',
	clothes: 'clothes',
	item: 'items',
	layer: 'layers',
	background: 'backgrounds',
	audio: 'audio',
};
